import { API_VERSION } from './api'
import EnvironmentService from './services/EnvironmentService'
import UserService from './services/UserService'

const hostUrl = EnvironmentService.getHostUrlValue()
export class BaseURLBuilder {
  base: string
  defaultParams: Record<string, string>

  constructor(base = hostUrl, defaultParams: Record<string, string> = {}) {
    this.base = base
    this.defaultParams = defaultParams
  }

  build = (path: string, params: Record<string, string> = {}) => {
    const url = new URL(path, this.base)
    const searchParams = { ...this.defaultParams, ...params }
    Object.entries(searchParams).forEach((param) => url.searchParams.append(...param))
    return url
  }
}

export class ApiURLBuilder extends BaseURLBuilder {
  constructor(base = hostUrl, defaultParams: Record<string, string> = {}) {
    super(`${base}${API_VERSION}/`, defaultParams)
  }
}

export class URLBuilderWithCustomer extends ApiURLBuilder {
  constructor(base = hostUrl, defaultParams: Record<string, string> = {}) {
    super(base, { ...defaultParams, 'Customer-Id': UserService.customerId.toString() })
  }
}

export class HomepageURLBuilder extends BaseURLBuilder {
  constructor() {
    super(hostUrl)
  }

  register = () => this.build('/authentication/sign_up')
  mieten = () => this.build('/mieten')
}
